<template>
  <material-card
    :title="$t('components.contributionscontrol.termadd.title')"
    :color="$vuetify.theme.themes.light.success"
    icon="add"
    v-if="dialog"
  >
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        v-if="item !== null && item !== undefined"
      >
        <v-container>
          <div class="row">
            <div class="col-12 col-md-12">
              <trans-textbox
                style="min-width: 200px"
                :label="$t('headers.contributionterms.name')"
                :rules="[$rules.required]"
                field="Name"
                class="required"
                v-model="item"
              ></trans-textbox>
            </div>
            <div class="col-12 col-md-12">
              <pbas-date-picker
                :label="$t('globals.start_date')"
                :value="item.StartDate"
                @update-date="item.StartDate = $event"
                :rules="[$rules.required, (val) => startDateRules(val)]"
                class="required"
                :allowedDates="(val) => allowedStartDates(val, item)"
              />
            </div>
            <div class="col-12 col-md-12">
              <pbas-date-picker
                :label="$t('globals.end_date')"
                :value="item.EndDate"
                @update-date="item.EndDate = $event"
                :rules="[$rules.required, (val) => endDateRules(val, item)]"
                class="required"
                :allowedDates="(val) => allowedEndDates(val, item)"
              />
            </div>
            <div class="col-12 col-md-12">
              <v-checkbox
                :label="$t('headers.contributionterms.completed')"
                v-model="item.IsCompleted"
              />
            </div>
          </div>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text @click="$emit('close')">
        {{ $t("globals.close") }}
      </v-btn>
      <v-btn :disabled="!valid" color="primary" @click="$emit('save', item)">
        {{ $t("globals.save") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import ErrorHandler from "../../components/ErrorHandler";
import TransTextbox from "../../components/TransTextbox";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    ErrorHandler,
    TransTextbox,
  },
  props: {
    dialog: Boolean,
    saving: Boolean,
  },
  data: () => ({
    valid: false,
    error: null,
    item: null,
    rules: {
      startDate: (v, s) => {
        if (v === undefined || v === null || v === "") {
          return true;
        }
        if (
          s.planIdentity === null ||
          s.planIdentity === undefined ||
          s.planIdentity.FirstRenewalDate === null ||
          s.planIdentity.FirstRenewalDate === undefined
        ) {
          return true;
        }
        const n = Date.parse(s.planIdentity.FirstRenewalDate);
        const d = new Date(n);
        if (!s.isDate(v)) {
          return s.$t("validation.date_{0}", [s.formatValidationDate(d)]);
        }
        const val = new Date(Date.parse(v));
        return (
          val >= d || s.$t("validation.date_{0}", [s.formatValidationDate(d)])
        );
      },
      endDate: (v, item, s) => {
        if (v === undefined || v === null || v === "") {
          return true;
        }
        if (
          item === null ||
          item === undefined ||
          item.StartDate === null ||
          item.StartDate === undefined
        ) {
          return true;
        }
        const n = Date.parse(item.StartDate);
        const d = new Date(n);
        if (!s.isDate(v)) {
          return s.$t("validation.date_{0}", [s.formatValidationDate(d)]);
        }
        const val = new Date(Date.parse(v));
        return (
          val >= d || s.$t("validation.date_{0}", [s.formatValidationDate(d)])
        );
      },
    },
  }),
  watch: {
    dialog: {
      handler(v) {
        if (v) {
          this.item = {
            Identifier: Math.random(),
          };
        }
      },
    },
  },
  computed: {
    ...mapGetters("plansMembers", {
      columnsDropDownOptions: "options",
      planColumnsOptions: "planOptions",
      planIdentity: "planIdentity",
    }),
  },
  mounted() {
    this.item = {
      Identifier: Math.random(),
    };
  },
  methods: {
    isDate(val) {
      if (
        new RegExp(/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/).test(
          val
        )
      ) {
        return !isNaN(Date.parse(val));
      }
      return false;
    },
    formatValidationDate(d) {
      let month = (d.getUTCMonth() + 1).toString();
      if (month.length === 1) {
        month = "0" + month;
      }
      let day = d.getUTCDate().toString();
      if (day.length === 1) {
        day = "0" + day;
      }
      return `${d.getUTCFullYear()}-${month}-${day}`;
    },
    startDateRules(val) {
      return this.rules.startDate(val, this);
    },
    endDateRules(val, item) {
      return this.rules.endDate(val, item, this);
    },
    allowedStartDates(val, item) {
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(this.planIdentity.FirstRenewalDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
    allowedEndDates(val, item) {
      const n = Date.parse(val);
      const d = new Date(n);
      let n2 = Date.parse(item.StartDate);
      const d2 = new Date(n2);
      return d >= d2;
    },
  },
};
</script>
